// extracted by mini-css-extract-plugin
module.exports = {"box":"BookDetailFact__box","container":"BookDetailFact__container"};